// External imports
import { Dispatch, SetStateAction } from "react";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";

// Local imports
import classes from "./style.module.css";
import languageConfig from "@/export/config";
import ChevronIcon from "@/app/assets/vectors/ChevronIcon";

// Component props for SelectMenu
interface Props {
  text: string;
  setText: Dispatch<SetStateAction<string>>;
}

export default function SelectMenu({ text, setText }: Props) {
  return (
    <Menu
      containerProps={{
        style: {
          width: "100%",
        },
      }}
      align="end"
      menuClassName={`${classes.select}`}
      menuButton={({ open }) => (
        <MenuButton className={`${classes.selectButton}`}>
          <ChevronIcon
            className={`${classes.selectButtonIcon} ${open && classes.open}`}
          />
        </MenuButton>
      )}
    >
      {languageConfig?.routes.fonts?.input.textOptions.map((option) => (
        <MenuItem
          key={option.replaceAll(" ", "_")}
          type="radio"
          className={({ hover }) =>
            `${classes.selectOption} ${hover && classes.hovered} ${
              option === text && classes.active
            }`
          }
          value={option}
          onClick={(e) => setText(e.value)}
        >
          {option}
        </MenuItem>
      ))}
    </Menu>
  );
}
